import { IoGift } from "react-icons/io5";
import { BiSolidTimer } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { HiBuildingStorefront } from "react-icons/hi2";

const ThreeGridMenu = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-md pb-20 mt-4">
      <hr className="my-4" />
      <section className="grid grid-cols-3 gap-6 w-full max-w-md">
        {/* 랜덤팩 픽업 */}
        <button
          onClick={() => navigate("/boss/my/store-management")}
          className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center relative space-y-2"
        >
          <HiBuildingStorefront className="w-8 h-8 text-blue-400" />
          <span className="text-lg text-gray-700 font-semibold">매장 설정</span>
        </button>

        {/* 랜덤팩 관리 */}
        <div className="w-full h-full">
          <button
            onClick={() => {
              navigate("/boss/pre-order/pack-management");
            }}
            className="w-full bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
          >
            <IoGift className="w-8 h-8 text-blue-400" />
            <span className="text-lg text-gray-700 font-semibold">팩 설정</span>
          </button>
        </div>

        {/* 픽업시간 설정 */}
        <div className="w-full h-full">
          <button
            onClick={() => {
              navigate("/boss/pre-order/pickup-time-update");
            }}
            className="w-full bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
          >
            <BiSolidTimer className="w-8 h-8 text-blue-400" />
            <span className="text-lg text-gray-700 font-semibold">
              픽업시간 설정
            </span>
          </button>
        </div>
      </section>
    </div>
  );
};

export default ThreeGridMenu;
